"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecommendedProducts = getRecommendedProducts;
exports.getRecommendedArticles = getRecommendedArticles;
exports.getRecommendedTips = getRecommendedTips;
const axios_1 = __importDefault(require("axios"));
var META_TYPE;
(function (META_TYPE) {
    META_TYPE["PRODUCT"] = "product";
    META_TYPE["ARTICLE"] = "article";
    META_TYPE["STATIC"] = "static";
})(META_TYPE || (META_TYPE = {}));
function formatProductsResponse(recommendedProducts = []) {
    const formattedResponse = [];
    recommendedProducts.forEach((product) => {
        if (product.recommendations) {
            formattedResponse.push(...product.recommendations);
        }
        else {
            if (typeof product === 'object' && product !== null && typeof product[Symbol.iterator] === 'function') {
                formattedResponse.push(...product);
            }
            else {
                formattedResponse.push(product);
            }
        }
    });
    return formattedResponse;
}
function getRecommendedProducts(assessmentResults, recommendationApiUrl, prApiKey, meta) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const productMeta = {
                type: meta.type ? meta.type : META_TYPE.PRODUCT,
                categories: meta.categories,
                division: meta.division,
                brand: meta.brandName,
                locale: meta.locale,
                version: meta.version,
                limit: meta.limit ? meta.limit : 10,
                offset: meta.offset ? meta.offset : 0,
            };
            if (meta === null || meta === void 0 ? void 0 : meta.channel) {
                productMeta['channel'] = meta === null || meta === void 0 ? void 0 : meta.channel;
            }
            if (meta === null || meta === void 0 ? void 0 : meta.journey_type) {
                productMeta['journey_type'] = meta === null || meta === void 0 ? void 0 : meta.journey_type;
            }
            const recommendedProductsResponse = yield (0, axios_1.default)({
                method: 'post',
                responseType: 'json',
                url: recommendationApiUrl,
                headers: {
                    'x-api-key': prApiKey,
                },
                data: {
                    meta: productMeta,
                    results: Object.assign({}, assessmentResults),
                },
            });
            let formatedResponse = {};
            if (meta === null || meta === void 0 ? void 0 : meta.section) {
                formatedResponse = recommendedProductsResponse.data.data;
            }
            else {
                formatedResponse = meta.type !== META_TYPE.PRODUCT ? recommendedProductsResponse.data.data : formatProductsResponse(recommendedProductsResponse.data.data);
            }
            return formatedResponse;
        }
        catch (error) {
            throw error.response;
        }
    });
}
function getRecommendedArticles(assessmentResults, ArticleRecommendationApiUrl, arApiKey, meta) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const articleMeta = {
                type: meta.type ? meta.type : META_TYPE.ARTICLE,
                categories: meta.categories,
                division: meta.division,
                brand: meta.brandName,
                locale: meta.locale,
                version: meta.version,
                limit: meta.limit ? meta.limit : 10,
                offset: meta.offset ? meta.offset : 0,
            };
            if (meta === null || meta === void 0 ? void 0 : meta.channel) {
                articleMeta['channel'] = meta === null || meta === void 0 ? void 0 : meta.channel;
            }
            if (meta === null || meta === void 0 ? void 0 : meta.journey_type) {
                articleMeta['journey_type'] = meta === null || meta === void 0 ? void 0 : meta.journey_type;
            }
            const recommendedArticlesResponse = yield (0, axios_1.default)({
                method: 'post',
                responseType: 'json',
                url: ArticleRecommendationApiUrl,
                headers: {
                    'x-api-key': arApiKey,
                },
                data: {
                    meta: articleMeta,
                    results: Object.assign({}, assessmentResults),
                },
            });
            return recommendedArticlesResponse.data.data;
        }
        catch (error) {
            throw error.response;
        }
    });
}
function getRecommendedTips(assessmentResults, tipRecommendationApiUrl, tpApiKey, meta) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const tipsMeta = {
                type: meta.type ? meta.type : META_TYPE.STATIC,
                categories: meta.categories,
                division: meta.division,
                brand: meta.brandName,
                locale: meta.locale,
                version: meta.version,
                limit: meta.limit ? meta.limit : 10,
                offset: meta.offset ? meta.offset : 0,
            };
            const recommendedTips = yield (0, axios_1.default)({
                method: 'post',
                responseType: 'json',
                url: tipRecommendationApiUrl,
                headers: {
                    'x-api-key': tpApiKey,
                },
                data: {
                    meta: tipsMeta,
                    results: Object.assign({}, assessmentResults),
                },
            });
            return recommendedTips.data.data;
        }
        catch (error) {
            throw error.response;
        }
    });
}
